/* eslint-disable */
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const useSnippets = (load = false) => {
  const { snippets, quickReplySnippets } = useSelector(state => state.snippets) || {};
  const dispatch = useDispatch();

  const create = async ({ payload }) => {
    await dispatch.snippets.create({ payload });
  };

  const deleteSnippet = async ({ id }) => {
    await dispatch.snippets.delete({ id });
  };

  const update = async ({ payload }) => {
    await dispatch.snippets.update({ payload });
  };

  useEffect(() => {
    if (load && snippets.length === 0) {
      dispatch.snippets.load();
    }
  }, []);

  return {
    create,
    deleteSnippet,
    update,
    snippets,
    quickReplySnippets,
  };
};

export default useSnippets;
